import React from 'react'
import DefaultLayout from '~/layouts/default'
import QuizLayout from '~/layouts/quiz'

export const wrapPageElement = ({ element, props }) => {
  const Layout = props.pageContext.quiz ? QuizLayout : DefaultLayout
  return <Layout {...props}>{element}</Layout>
}
